export default __webpack_public_path__ + "static/ethereum-ce691dcef374b5c4a15871fbe6647468.svg";